// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d378bcf","239":"d497ac53","455":"8253400e","975":"05f5d13f"}[chunkId] + ".chunk.js";
};